export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <h3 className="text-xl font-heading font-bold text-background-50 mb-4">
                51吃瓜黑料网
              </h3>
              <p className="text-sm text-background-400 leading-relaxed">
                汇聚吃瓜群众，围观热门事件。实时盘点吃瓜爆料第一站，加入网友热议，体验最真实的吃瓜现场。每日更新，不错过任何一个热点。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2">
                <li><a href="#topics" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">热门话题</a></li>
                <li><a href="#ranking" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">热度榜单</a></li>
                <li><a href="#updates" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">最新快讯</a></li>
                <li><a href="#faq" className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer">常见问题</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                合作伙伴
              </h4>
              <p className="text-sm text-background-400">
                更多合作伙伴正在加入中
              </p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-background-500">
                &copy; {new Date().getFullYear()} 51吃瓜黑料网 —— 吃瓜爆料第一站。本站内容仅供娱乐参考。
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors cursor-pointer">隐私政策</a>
                <a href="#" className="text-xs text-background-500 hover:text-accent-400 transition-colors cursor-pointer">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}